import { render, staticRenderFns } from "./Monitoramento.vue?vue&type=template&id=3a1707f8&"
import script from "./Monitoramento.vue?vue&type=script&lang=js&"
export * from "./Monitoramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports